module.exports = __webpack_public_path__ + "img/communications.87cb68e9.svg";